/**
 * Scheduled Emails Service
 *
 * Mass emails waiting to go out, once or on repeat. Creating one goes
 * through adminService.scheduleBulkEmail (the composer's form); everything
 * after that lives here. An owner manages all of them; an admin manages
 * the ones they scheduled.
 */

import apiClient from "../client";
import { API_ENDPOINTS } from "../../constants/api.constants";

const base = API_ENDPOINTS.ADMIN.SCHEDULED_EMAILS;

const scheduledEmailsService = {
  /** @returns {Promise<{items: Array, total: number}>} next to go first */
  async list(params = {}) {
    const query = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null),
    );
    const { data } = await apiClient.get(base, { params: query });
    return data;
  },

  /** Only the fields given change; attachments stay as scheduled. */
  async update(id, changes) {
    const { data } = await apiClient.patch(`${base}/${id}`, changes);
    return data;
  },

  async pause(id) {
    const { data } = await apiClient.post(`${base}/${id}/pause`);
    return data;
  },

  /** Picks up at the next send still to come; missed ones are skipped. */
  async resume(id) {
    const { data } = await apiClient.post(`${base}/${id}/resume`);
    return data;
  },

  async cancel(id) {
    const { data } = await apiClient.post(`${base}/${id}/cancel`);
    return data;
  },
};

export default scheduledEmailsService;
